import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { UiStorage } from '../../services/ui-storage'

@Component({
    standalone: false,
    selector: 'navigation-bar',
    templateUrl: './navigation-bar.component.html',
    styleUrls: ['./navigation-bar.component.css'],
})
export class NavigationBarComponent {
    @Input() model: any;

    @Input('current-index') currentIndex: number = 1;

    constructor(private _router: Router, private _storage: UiStorage) { }

    onVerzekerdeClick() {
        this._storage.save(this.model);
        this._router.navigate(['/verzekerde']);
    }

    onAdviesClick() {
        this._storage.save(this.model);
        this._router.navigate(['/advies']);
    }
}
